import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TenantManagementListState } from "../types/TenantManagementListType";
import { getSelectedUser, isSystemError, ACTION_USER_ACTIVATION } from '../utils/tenantManagmentTableCommon';

export const initialState: TenantManagementListState = {
  data: [],
  isLoading: true,
  isLoadingOnAction: false,
  error: "",
  totalRecords: 0,
  currentPage: 1,
  isDataNeedToReload: false,
  selectedUserDetails: null,
  showBanner: {
    isActive: false,
    message: "",
  },
  showErrorModal: {
    isActive: false,
    message: "",
  },
  updateUserStatus: {
    error: "",
  },
};

export const tenantManagementListSlice = createSlice({
  name: "tenantManagementlist",
  initialState: initialState as TenantManagementListState,
  reducers: {
    fetchRequest: (state: TenantManagementListState, action) => {
      state.isLoading = true;
    },
    fetchSuccess: (
      state: TenantManagementListState,
      action: PayloadAction<TenantManagementListState>
    ) => {
      const {
        payload: { data, totalRecords, currentPage },
      } = action;
      state.data = data;
      state.totalRecords = totalRecords;
      state.currentPage = currentPage;
      state.isLoading = false;
    },
    fetchFailure: (state: TenantManagementListState, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setDataReload: (state: TenantManagementListState, action) => {
      state.isDataNeedToReload = action.payload;
    },
    closeBanner: (state: TenantManagementListState) => {
      state.showBanner.isActive = false;
      state.showBanner.message = "";
      state.selectedUserDetails = null;
    },
    closeErrorModal: (state: TenantManagementListState) => {
      state.showErrorModal.isActive = false;
      state.showErrorModal.message = "";
      state.selectedUserDetails = null;
    },
    updateTenantStatusRequest: (state: TenantManagementListState, action) => {
      const { userId } = action.payload;
      state.selectedUserDetails = getSelectedUser(state.data, userId);
      state.isLoadingOnAction = true;
    },
    updateRequestFailure: (state: TenantManagementListState, action) => {
      const { type = "", message = "" } = action.payload;
      const showErrorInModal = isSystemError(type);
      if (showErrorInModal) {
        state.showErrorModal.isActive = showErrorInModal;
        state.showErrorModal.message = message;
      }
        state.updateUserStatus.error = message;
      
      state.isLoadingOnAction = false;
    },
    updateRequestSuccess: (state: TenantManagementListState, action) => {
      state.showBanner.message = `Success${ACTION_USER_ACTIVATION}`;
      state.showBanner.isActive = true;
      state.isLoadingOnAction = false;
      state.isDataNeedToReload = true;
    },
  },
});

export const {
  fetchRequest,
  fetchFailure,
  fetchSuccess,
  setDataReload,
  closeBanner,
  closeErrorModal,
  updateTenantStatusRequest,
  updateRequestFailure,
  updateRequestSuccess,
} = tenantManagementListSlice.actions;
export default tenantManagementListSlice.reducer;
